<template>
	<el-form @submit.native.prevent="validateSearch" ref="search_form" :model="form_model" label-position="top" class="search-form" :class="{'search-form-visible': show_search_form}">
		<jurisdiction></jurisdiction>
		<hr>
		<defendant></defendant>
		<hr>
		<attorney-judge></attorney-judge>
		<hr>
		<div class="sub_panel">
			<el-button :loading="is_loading" size="large" native-type="submit">SEARCH BOND EVENTS</el-button>
		</div>
	</el-form>
</template>

<script>
import jurisdiction from './search-sub-components/Jurisdiction.vue'
import defendant from './search-sub-components/Defendant.vue'
import attorneyJudge from './search-sub-components/Attorney-Judge.vue'
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import debounce from 'lodash.debounce';
export default{
	components: {
		jurisdiction, defendant, attorneyJudge
	},
	computed: {
		...mapFields(['is_loading']),
		form_model(){
			return this.$store.state;
		}
	},
	methods: {
		...mapActions(['startSearch', 'validateSearchOverall']),
		// validateField(field){
		// 	this.$refs.search_form.validateField(field);
		// },
		async validateSearch(){
			this.show_search_form = false;
			const valid_overall = await this.validateSearchOverall(); // action returns promise that required await for solution
			this.$refs.search_form.validate( (valid_fields) => {
				if(valid_fields && valid_overall){
					this.is_loading = true;
					this.initSearch();
				} else {
					this.$notify({
						title: 'Warning',
						message: "You must provide at least one search criteria.",
						type: 'warning'
					});
					this.is_loading = false;
				}
			})
		},
		initSearch: debounce(function(){
			this.startSearch();
		}, 1000, { leading: true })
	},
	data(){
		return {
			show_search_form: true
		}
	}
}
</script>

<style>
/* Asterisk adjustment to right of form-item */
.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before{
	content: '';
	margin-right: 0px;
}
.el-form-item.is-required .el-form-item__label:after{
	content: '*';
	color: #f56c6c;
	margin-left: 4px;
}
/* End asterisk adjustment */
</style>

<style scoped>

hr{
	display: block;
	height:1px;
	border:0;
	border-top:1px solid #ccc;
	margin:0;
	padding:0;
}

.search-form{
	/* min-width: 280px; */
	background-color: white;
	color: #474554;
	box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
	border-radius: .25rem;
	border:1px solid rgba(0,0,0,.125);
	height:100%;
	line-height:1;
	flex-shrink:0;
}

.search-form .sub_panel{
	padding:20px;
}

.search-form >>> .el-input__icon{
	color:#359DB4;
	font-size:18px;
	margin-left:5px;
}


.search-form >>> .panel_detail{
	margin-top:20px;
}
.el-button{
	width: 100%;
	box-sizing: border-box;
	background-color: #359DB4;
	color:white;
	transition: .1s all linear;
	font-family:'Lato';
}

.el-button:hover{
	transform: scale(1.05);
}

.search-form >>> .el-form-item{
	margin-bottom:12px;
}

.search-form >>> .is-error{
	margin-bottom:30px;
}

.search-form >>> .el-form-item__label{
	line-height: normal;
	color: rgba(120,117,134,0.5);
	padding-bottom:2px;
	font-size:12px;
}

.search-form >>> .el-input__inner{
	background-color: #EFEDF8;
	color: #359DB4;
	font-family:'Lato';
}

.jurisdiction[data-v-4e1c5f8e] .el-radio-button__inner{
	font-family:'News Cycle';
	letter-spacing:0;
}

</style>
